import React from "react";
import moment from "moment";
import { centHundredthsToString } from "utils/moneyFormat";
import classnames from "classnames";
import { colorClassForOrder, statusTextForOrder } from "utils/orderStatus";
import BalanceMinutesOrdersRecordRowCancelFooter from "./BalanceMinutesOrdersRecordRowCancelFooter";

interface Props {
    order: sage.model.IOrder;
}

const BalanceMinutesOrdersRecordRow: React.FC<Props> = ({ order }) => {
    const createdAt = moment(new Date(order.created_at)).fromNow();

    return (
        <div className="list-group-item">
            <div className="d-flex align-items-center justify-content-between">
                <h5>Order from {createdAt}</h5>
                <span
                    className={classnames(
                        "badge badge-pill",
                        `badge-${colorClassForOrder(order)}`
                    )}
                >
                    {statusTextForOrder(order)}
                </span>
            </div>
            <p>
                {order.minutes_fulfilled} of {order.minutes} minutes fulfilled,
                at {centHundredthsToString(order.price_cent_hundredths)} each
            </p>
            <BalanceMinutesOrdersRecordRowCancelFooter order={order} />
        </div>
    );
};

export default BalanceMinutesOrdersRecordRow;
